import { Paper, colorsPalette, styled } from '@lingoda/ui';

export const ClassDetailsTilePaperStyled = styled(Paper)({
    borderWidth: '1px',
    borderColor: colorsPalette.blackAlpha[20],
    overflow: 'hidden',
});
